import PropTypes from 'prop-types';

import './CategoryCard.scss';

const CategoryCard = ({
  title,
  description,
  renderIcon,
  onClick,
  dataTest = ''
}) => {
  return (
    <div
      className="category-card"
      onClick={onClick}
      role="button"
      tabIndex={0}
      data-test={dataTest}
    >
      <div className="category-card__info">
        <h2 className="category-card__title">{title}</h2>
        <p className="category-card__description">{description}</p>
      </div>
      <div className="category-card__icon">{renderIcon()}</div>
    </div>
  );
};

CategoryCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  renderIcon: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  dataTest: PropTypes.string
};

export default CategoryCard;
